// TODO: Should be removed once we refactor the special components' types.
// Note: The component metadata shouldn't be used for such purposes.

/** The component names for temp use only. */
export const TEMP_FIELD_COMPONENT_NAMES = {
  categoryComponent: 'CategoryComponent',
  switchComponent: 'SwitchComponent',
  monthComponent: 'MonthComponent',
  monthYearComponent: 'MonthYearComponent',
  yearComponent: 'YearComponent',
  numberComponent: 'NumberComponent',
  userReferenceComponent: 'UserReferenceComponent',
  textComponent: 'TextInputComponent',
  localizedTextComponent: 'LocalizedTextInputComponent',
  longTextComponent: 'LongTextComponent',
  LocalizedLongTextInputComponent: 'LocalizedLongTextInputComponent',
  ImageComponent: 'ImageComponent',
  VideoComponent: 'VideoComponent',
  FileComponent: 'FileComponent',
  DocumentComponent: 'DocumentComponent',
};

export const CONNECTED_COMPONENT_IDENTIFIER = 'connected-to';
